import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block text-xs font-semibold text-neutral-600 mb-3" }
const _hoisted_2 = { class: "flex flex-col space-y-2" }

import { ref } from "vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldWidthRadio',
  props: {
	form: {
		type: Object,
	},
    value: {
        default: null,
        required: true,
    },
    label: {
        type: String,
        default: 'Choose field width',
    },
    error: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;
const form = ref<object>(props.form);
const field_width_options = [
    { id: '1', label: 'Whole', value: 'col-span-3', radioSelected: null},
    { id: '2', label: 'Half', value: 'col-span-6', radioSelected: null},
]



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(RadioGroup, {
        options: field_width_options,
        name: "field_width"
      })
    ])
  ]))
}
}

})